import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './denunciaForm';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista } from './denunciaActions';

class Denuncia extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		/*
		1 - Janiel
		4 - PEDRO AUGUSTO PEIXOTO RODRIGUES
		74 - Artur Gonçalves Rodrigues
		56 - Camila Faverao Inheta
		*/
		const usuarioadm = this.props.sessao ? [1, 4, 74, 56].includes(this.props.sessao.id) : false;

		return (
			<ContentCard>
				<ContentCardBody>

					{!usuarioadm &&
					<>
						<Row alignCenter>
							<Grid cols='12 12 12 12'>
								<p style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', marginTop: 24 }}>Portal de Denúncias e Reclamações</p>
							</Grid>
						</Row>
						<Row alignCenter>
							<Grid cols='12 6 4 2'>
								<p style={{ fontSize: 14, textAlign: 'center', marginTop: 16 }}>
									Use este espaço para registrar qualquer reclamação ou denúncia que você identificar no seu dia a dia. Sua contribuição é essencial para melhorarmos continuamente.
								</p>
							</Grid>
						</Row>
						<Row alignCenter style={{ marginTop: 16, marginBottom: 24 }}>
							<Grid cols='6 6 4 2'>
								<Button
									text='Adicionar Denúncia ou Reclamação'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.setModoTela('cadastro', {});
										this.props.initForm({});
									}} />
							</Grid>
						</Row>
					</>}

					{usuarioadm &&
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Data</Th>
								<Th colspan={1}>Denúncia ou Reclamação</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
									<Td>{(item.descricao).split('\n').map((linha, i) => (
										<p key={i} style={{ padding: 0, margin: 0 }}>{linha}</p>
									))}</Td>
								</Tr>
							))}
						</TBody>
					</Table>}
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.denuncia.modoTela,
	lista: state.denuncia.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Denuncia);
